// Pessoas da mesa aberta, pro seletor do garçom e o "pagar por pessoa" do caixa.
import { useCallback, useEffect, useRef, useState } from "react";

import { criarPessoa, listarPessoas } from "./api";

export function usePessoasMesa(mesa, ativo) {
  const [pessoas, setPessoas] = useState([]);
  const [pagos, setPagos] = useState([]);
  const [logQr, setLogQr] = useState([]);
  const [removidos, setRemovidos] = useState([]);
  const [qrLigado, setQrLigado] = useState(false);
  // Dono de cada produto pela regra do servidor (item antigo do QR sem
  // `_cliente_id` tem o dono no pedido da rodada) e se o "dar saída" vale
  const [donos, setDonos] = useState({});
  const [saidaLigada, setSaidaLigada] = useState(false);
  const mesaId = mesa?.id;
  const aberta = !!mesa?.opened_at;
  // Resposta que saiu antes de uma mudança local (pagamento apagado) é velha:
  // não entra, senão remarcaria como pago o que acabou de sair
  const geracao = useRef(0);
  const invalidar = useCallback(() => { geracao.current += 1; }, []);
  // Enquanto a lixeira grava a mesa, nenhuma resposta entra
  const pausado = useRef(false);
  const pausar = useCallback((sim) => { pausado.current = !!sim; }, []);

  const recarregar = useCallback(async () => {
    const minha = geracao.current;
    if (!mesaId || !aberta) {
      setPessoas([]);
      setPagos([]);
      setLogQr([]);
      setRemovidos([]);
      setDonos({});
      return null;
    }
    try {
      if (pausado.current) return null;
      const { data } = await listarPessoas(mesaId);
      if (pausado.current || minha !== geracao.current) return null;
      setPessoas(data?.pessoas || []);
      setPagos(data?.pagos || []);
      setLogQr(data?.log_qr || []);
      setRemovidos(data?.removidos || []);
      setQrLigado(!!data?.qr_ligado);
      setDonos(data?.donos || {});
      setSaidaLigada(!!data?.saida_ligada);
      return data || null;
    } catch {
      return null;
    }
  }, [mesaId, aberta]);

  // Quem escaneia o QR com a mesa já aberta no painel aparece sozinho
  useEffect(() => {
    if (!ativo) return undefined;
    recarregar();
    const id = setInterval(recarregar, 15000);
    return () => clearInterval(id);
  }, [ativo, recarregar]);

  const criar = useCallback(async (nome, cpf) => {
    const { data } = await criarPessoa(mesaId, { nome, cpf: cpf || null });
    await recarregar();
    return data;
  }, [mesaId, recarregar]);

  return { pessoas, pagos, logQr, removidos, donos, saidaLigada, aberta, qrLigado, recarregar, invalidar, pausar, criar };
}
